import React, { useState, useRef } from 'react';
import styled from '@emotion/styled';

import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Button, TextField, IconButton} from '@mui/material';
import { ExpandMore, CloudUpload, Podcasts } from '@mui/icons-material';

import GenericDetailsTable from '../../Layout/Table/GenericDetailsTable';

import useErrorManager from "../../../hooks/useErrorManager";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNotification } from '../../../contexts/NotificationContext';
import { useNavigate } from 'react-router-dom';

function NetworkInfo({ details }) {
 
    const fileInputRef = useRef(null);

    const { setError, clearError } = useErrorManager();
    const { showNotification } = useNotification();
    const axiosInstance = useAxiosPrivate();
    const navigate = useNavigate();

    const detailsView = [
        { key: 'networkNumber', label: 'Network Number' },
        { key: 'networkDescription', label: 'Network Description' },
        // { key: 'networkDescription', label: 'Network Description', render: (item) => editMode ? (
        //     <EditableTextField 
        //         value={editedDetails?.networkDescription || ''} 
        //         onChange={(e) => handleInputChange('networkDescription', e.target.value)} 
        //     />
        // ) : (
        //   item.networkDescription
        // ) },
        { key: 'status', label: 'Network Status', render: (item) => renderNetStatus(item.errorCodes) },
        { key: 'nodeCount', label: 'Network Nodes' },
        { key: 'meterCount', label: 'Meters' },
        { key: 'lastConnect', label: 'Last connection', render: (item) => formatDateTime(item.lastConnect) },
        { key: 'fullId', label: 'Full network ID', render: (item) => `${item.networkNumber}:${item.networkSerial}` },
        { key: 'nodeMinVersion', label: 'Min. Node Version' },
        { key: 'import', label: 'Import PLT file list',  render: (item) =>  
                <IconButton onClick={() => fileInputRef.current && fileInputRef.current.click()} variant="contained" color="primary">
                    <CloudUpload />
                </IconButton>
        },
        { key: 'changeNwMode', label: 'Change Network mode',  render: (item) =>  
                <IconButton onClick={() => navigate(`/networks/${details.networkId}/change-mode`)} variant="contained" color="primary">
                    <Podcasts />
                </IconButton>
        }


    ];


    const renderNetStatus = (dataType) => {
        const errorCodes = {
            "40": "Failure",
            "136": "Permanent communications error",
            "144": "Temporary communications error"
        };

        const codes = dataType.split(',');

        // Check if the only code is "0"
        if (codes.length === 1 && codes[0] === "0") {
            return "OK";
        }

        const translations = codes.filter(code => code !== "0").map(code => errorCodes[code]);
        // Join the translations with a comma and return the result
        return translations.join(', ');
    };



    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
    
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
    
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
    
        return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
    };


    const handleFileImport = async (file) => {
        try {
          const formData = new FormData();
          formData.append("file", file, file.name);
          
          await axiosInstance.post(`/net/list/${details.networkId}/plt`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });
          
          showNotification("PLT file imported successfully", "success");
        } catch (error) {
          setError("importMetersList", error.message);
          showNotification("Failed to import PLT file: " + error.message, "error");
        }
    };  

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && handleFileImport) {
            handleFileImport(file);
        }
        event.target.value = '';
    };


    return (
        <Accordion defaultExpanded={true}> 
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="h7">GENERAL INFORMATION</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <input
                    type="file"
                    accept=".plt"
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                />
                <GenericDetailsTable
                    detailsValue={details}
                    detailsList={detailsView} />

            </AccordionDetails>
        </Accordion>
    );
}

export default NetworkInfo;
